<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" role="doc-part">
<h1 class="h1p"><span aria-label="xi" epub:type="pagebreak" id="page_xi" role="doc-pagebreak" title="xi"><span aria-label="xii" epub:type="pagebreak" id="page_xii" role="doc-pagebreak" title="xii"><span aria-label="1" epub:type="pagebreak" id="page_1" role="doc-pagebreak" title="1">Act I <span class="heading_break">THE FARMER</span><span aria-label="2" epub:type="pagebreak" id="page_2" role="doc-pagebreak" title="2"></span></span></span></span></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?98978f16